"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootSaga = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sagas_1 = require("./sagas");
function rootSaga() {
    var e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, effects_1.all([
                        sagas_1.loadAttributeWorker,
                        sagas_1.loadInitialElementsPageWorker,
                        sagas_1.loadNextElementsPageWorker,
                        sagas_1.loadCustomElementsWorker,
                        sagas_1.initWorker,
                    ].map(function (worker) { return effects_1.fork(worker); }))];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                console.error("Root saga failed", e_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}
exports.rootSaga = rootSaga;
//# sourceMappingURL=rootSaga.js.map